module.exports = __webpack_public_path__ + "static/slide9_img.3ece9803.png";